import { createSlice } from '@reduxjs/toolkit';

const initialState = () => {
  return {
    /**
     * Cart expiration date to display the countdown
     * @type {string|null}
     */
    expirationDate: null
  };
};

export const persistedCart = createSlice({
  name: 'persistedCart',
  initialState: { ...initialState() },
  reducers: {
    setCartExpirationDate: (state, action) => {
      state.expirationDate = action.payload;
    },
    resetPersistedCart: (state) => {
      Object.assign(state, initialState());
    }
  }
});

export const { setCartExpirationDate, resetPersistedCart } = persistedCart.actions;

export default persistedCart.reducer;
